import script from "./FlexNode.vue?vue&type=script&setup=true&lang=js"
export * from "./FlexNode.vue?vue&type=script&setup=true&lang=js"

import "./FlexNode.vue?vue&type=style&index=0&id=5d0cbc88&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d0cbc88"]])

export default __exports__